import { useEffect, useRef } from 'react';

type useIntervalCallback = (...args: any[]) => void;

const useInterval = (callback: useIntervalCallback, delay: number, condition = true) => {
    const savedCallback = useRef<useIntervalCallback>();
    useEffect(
        () => {
            savedCallback.current = callback;
        },
        [callback]
    );

    useEffect(
        () => {
            //@ts-ignore
            const handler = (...args) => condition && savedCallback.current(...args);

            if (delay !== null) {
                const id = setInterval(handler, delay);
                return () => clearInterval(id);
            }
        },
        [delay, condition]
    );
};

export default useInterval;
